import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconECommerce = ({
  title = "E-Commerce",
  color = "gray",
  viewBoxWidth = 24,
  viewBoxHeight = 34,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g id="IconECommerce" strokeWidth="1">
      <path
        d="M22,0 C22.5522847,0 24,1.44771525 24,2 L24,32 C24,32.5522847 22.5522847,34 22,34 L2,34 C1.44771525,34 0,32.5522847 0,32 L0,2 C0,1.44771525 1.44771525,0 2,0 L22,0 Z M8,2 L3,2 C2.44771525,2 2,2.44771525 2,3 L2,31 C2,31.5522847 2.44771525,32 3,32 L21,32 C21.5522847,32 22,31.5522847 22,31 L22,3 C22,2.44771525 21.5522847,2 21,2 L16,2 C16,3.1045695 15.1045695,4 14,4 L10,4 C8.9456382,4 8.08183488,3.18412221 8.00548574,2.14926234 L8,2 Z M19,22 L19,26 L5,26 L5,22 L19,22 Z M19,16 L19,20 L5,20 L5,16 L19,16 Z M19,10 L19,14 L5,14 L5,10 L19,10 Z"
        id="Combined-Shape"
        fill={uiColorToBaseColor(color)}
      />
    </g>
  </Svg.Icon>
)

export default IconECommerce
